<template>
  <div class="pa-2 linha-detalhe-panel__parametros">
    <div v-if="total > 1" class="parametros-pane__pager d-flex align-center mb-2">
      <v-btn
        icon
        small
        :disabled="page <= 0"
        :title="$t('crudLinhas.detail.parameters.previous')"
        @click="$emit('update:page', page - 1)"
      >
        <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>
      <div class="flex-grow-1 text-center px-2 text-truncate">
        <span class="caption font-weight-medium">
          {{ $t('crudLinhas.detail.parameters.pager', { current: page + 1, total }) }}
        </span>
        <span v-if="label" class="caption grey--text"> — {{ label }}</span>
      </div>
      <v-btn
        icon
        small
        :disabled="page >= total - 1"
        :title="$t('crudLinhas.detail.parameters.next')"
        @click="$emit('update:page', page + 1)"
      >
        <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
    </div>

    <v-alert
      v-if="total > 1"
      dense
      text
      type="info"
      class="caption mb-2 py-1"
    >
      {{ $t('crudLinhas.detail.parameters.unsavedWarning') }}
    </v-alert>

    <slot />

    <div v-if="canEdit && hasContent" class="d-flex justify-end pt-3">
      <v-btn color="primary" @click="$emit('save')">
        {{ $t('crudLinhas.messages.save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecursosOperacionaisParametrosPane",
  props: {
    canEdit: { type: Boolean, default: false },
    /** Há conteúdo no slot de parâmetros (controla o botão Salvar). */
    hasContent: { type: Boolean, default: false },
    /** Quantidade de itens selecionados; o paginador só aparece com > 1. */
    total: { type: Number, default: 0 },
    /** Página atual, base 0. */
    page: { type: Number, default: 0 },
    /** Rótulo do item da página atual (código — nome). */
    label: { type: String, default: null },
  },
};
</script>

<style scoped>
.parametros-pane__pager {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-bottom: 4px;
}
</style>
